<template>
  <div class="daten">
    <Header />
    <Hero step="daten" />
    <Daten />
    <SectionSplit />
    <DataSummary />
    <TicketsSummaryReservierung />
    <Footer />
    <SlideNavigation />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import Daten from '@/components/Daten.vue'
import SectionSplit from '@/components/SectionSplit.vue'
import DataSummary from '@/components/DataSummary.vue'
import TicketsSummaryReservierung from '@/components/TicketsSummaryReservierung.vue'
import Footer from '@/components/Footer.vue'
import SlideNavigation from '@/components/SlideNavigation.vue'

export default {
  name: 'DatenView',
  components: {
    Header,
    Hero,
    Daten,
    SectionSplit,
    DataSummary,
    TicketsSummaryReservierung,
    Footer,
    SlideNavigation
  },
  data() {
    return {}
  },
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>
